/* eslint-disable no-constant-condition */
import {
  GET_ROOM_RESULTS_REQUEST,
  GET_ROOM_RESULTS_SUCESS,
  GET_ROOM_RESULTS_FAIL,
  CHANGE_DISPLAY_ROOM,
  RESET_ROOM_RESULTS,
  RESET_DISPLAY_ROOM,
  SELECTION_RESET,
  PROMO_CODE_VALIDATION,
  TOGGLE_EXPANDBLE_VIEW_FOR_ROOM
} from "../constants/actionTypes";
import { getRooms, redirectToregistrationPage } from "../api/rooms";

import { generateAsyncAction } from "./generateAsyncAction";

export const getRoomResults = request => async dispatch => {
  dispatch({ type: GET_ROOM_RESULTS_REQUEST });
  const getRoomsAction = await generateAsyncAction({
    onFailAction: roomResultFailed,
    onSuccessAction: roomResultSuccess,
    asyncApiMethod: getRooms,
    request
  });
  return dispatch(getRoomsAction);
};

const roomResultSuccess = ({ payload }) => dispatch => {
  dispatch(roomsDataSuccess(payload));
  dispatch(promoCodeValidation(payload));
};

const roomsDataSuccess = payload => ({
  type: GET_ROOM_RESULTS_SUCESS,
  payload: payload && payload.rooms
});

const promoCodeValidation = payload => ({
  type: PROMO_CODE_VALIDATION,
  payload: payload.isPromoCodeValid
});

const roomResultFailed = ({ message, title }) => ({
  type: GET_ROOM_RESULTS_FAIL,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});

export const resetRoomResult = () => dispatch => {
  return dispatch({
    type: RESET_ROOM_RESULTS
  });
};

export const changeDisplayRoom = roomId => dispatch => {
  return dispatch({
    type: CHANGE_DISPLAY_ROOM,
    payload: roomId
  });
};

export const resetDisplayRoom = () => dispatch => {
  return dispatch({
    type: RESET_DISPLAY_ROOM
  });
};

export const resetSelection = () => dispatch => {
  return dispatch({
    type: SELECTION_RESET
  });
};

export const checkoutRooms = hotelId => async (dispatch, getState) => {
  const { paxList } = getState();
  const selectedSessions = paxList.map(pax => {
    return pax.rateId;
  });

  redirectToregistrationPage(selectedSessions, hotelId); // for now we will just redirect the location
};

export const toggleExpandbleRoomResultsView = payload => dispatch => {
  return dispatch({
    type: TOGGLE_EXPANDBLE_VIEW_FOR_ROOM,
    payload: payload
  });
};



// WEBPACK FOOTER //
// ./src/actions/roomResultsActions.js